import React from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import cn from 'clsx';
import DraggableDialog from '@components-clean/core/draggable-dialog';
import { TextAreaController } from '@components-clean/core/text-area';
import styles from '@pages-clean/subject-monitoring/components/dialogs/styles.module.scss';

type PanelReasonForChangeDialogProps = {
    onCancel: () => void;
    onSubmit: (reasonForChange: string) => Promise<void>;
};

interface IPanelReasonForChangeForm {
    reasonForChangeMessage: string;
}

const PanelReasonForChangeDialog = ({ onCancel, onSubmit }: PanelReasonForChangeDialogProps) => {
    const { t: managePanelsTranslation } = useTranslation('admin', { keyPrefix: 'managePanels' });

    const {
        control,
        handleSubmit,
        formState: { isDirty, isSubmitting, isValid },
    } = useForm<IPanelReasonForChangeForm>({ mode: 'all' });

    return (
        <DraggableDialog
            dataTestId="panel-reason-for-change"
            onSubmit={async () => {
                await handleSubmit(async (values: IPanelReasonForChangeForm) => {
                    if (values.reasonForChangeMessage.trim().length) {
                        await onSubmit(values.reasonForChangeMessage.trim());
                    }
                })();
            }}
            onClose={async () => {
                onCancel();
            }}
            title={managePanelsTranslation('reasonForChange')}
            primaryBtnDisabled={isSubmitting || !isDirty || !isValid}
            height={300}
        >
            <div className={cn('k-w-full', 'k-h-full', 'k-d-flex-col')}>
                <TextAreaController
                    control={control}
                    name="reasonForChangeMessage"
                    data-testid="delete-tag-reason-for-change-message"
                    fillMode="solid"
                    maxLength={4000}
                    required
                    label={`${managePanelsTranslation('reasonForChange')} *`}
                    className={styles.deleteReason}
                    validateRules={{
                        nonEmpty: (value) => {
                            if (!(value as string).trim().length) {
                                return 'This field is required';
                            }
                            return true;
                        },
                    }}
                />
            </div>
        </DraggableDialog>
    );
};

export default PanelReasonForChangeDialog;
